export const ElementStyle = {

  variants: {
    wrapper: {
      '.display': {
        display:'flex',
        minHeight:'360px',
      },
      '.display.left': {
        display: 'block !important',
        minHeight:'360px',
      },
      '.display.center': {
        justifyContent:'center',
      },
      '.display .heroImageBox': {
        width: '90%',
        display: 'flex',
        justifyContent: 'center',
      },
      '.display.left .heroImageBox': {
        margin: '0 auto',
      },
      '.display.right .heroImageBox': {
        margin: '0 auto',
      },
      '.display .heroImageImg': {
        width: [0, 0, 0, 'auto'],
      },
      '.display .formWrapper': {
        width: '60%',
      },
      '.display formWrapper qHeading': {
        fontSize: '24px',
      },
      '.display.left .formWrapper, .display.right .formWrapper': {
        margin: '2rem auto 0 auto',
        textAlign:'center',

      },
      '.display.center .instructions': {

        minHeight: [0, '400px', null, '500px'],
        padding: [0, 0, '16px'],
        border: '1px solid #333',
        borderRadius: '5px',
      },
      '.rsTextAreaVideoWrapper': {
        display: 'flex',
      },
      '.rsTextAreaVideoWrapper .heroImageBox, .display.left .heroImageBox': {
        width: '60%',
        display: 'flex',
        justifyContent: 'center',
      },
      '.rsTextAreaVideoWrapper .heroImageLeft, .display.left .heroImageLeft': {
        marginRight: '2rem',
      },
      '.rsTextAreaVideoWrapper .heroImageRight, .display.left .heroImageRight': {
        marginLeft: '2rem',
      },
      '.rsTextAreaVideoWrapper .heroImageImg, .display.left .heroImageImg ': {
        width: '100%',
        height: 'auto',
        border: '1px solid #333',
        borderRadius: '5px',
      },
      '.rsTextAreaVideoWrapper .formWrapper,.display.left .formWrapper': {
        width: '60%',
      },
      '.rsTextareaVideoWrapper Textarea': {
        height: '200px',
      },
    },
  },
};

